const testisSize = [
    { 
    label:"Side",
    controlType:"radio button",
    options:["Right", "Left", "Bilateral"]
    },

    {
    label:"Size (cm)",
    controlType:"text",
    options:[]
    },
    
    {label:"Duration:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
]

export default testisSize